import { render, staticRenderFns } from "./CheckOutBillList.vue?vue&type=template&id=228a7f99&scoped=true&"
import script from "./CheckOutBillList.vue?vue&type=script&lang=js&"
export * from "./CheckOutBillList.vue?vue&type=script&lang=js&"
import style0 from "./CheckOutBillList.vue?vue&type=style&index=0&id=228a7f99&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228a7f99",
  null
  
)

export default component.exports